import { api, apiAxiosInstance } from './api';

// pkg:calls https://swagger.launchmobility.io/backend#get_user_base
export const fetchUsers = (params, options) => {
  return api.get('/user', params, options);
};

// pkg:calls https://swagger.launchmobility.io/backend#get_driver_status_options
export const fetchUsersStatus = () => {
  return api.get('/user/driver_statuses');
};

// pkg:calls https://swagger.launchmobility.io/backend#get_user_by_id
export const fetchUserById = (id) => {
  return api.get(`/user/${id}`);
};

// pkg:calls https://swagger.launchmobility.io/backend#delete_user_by_id
export const fetchDeleteUser = (id, payload) => {
  return apiAxiosInstance
    .delete(`/user/${id}`, {
      data: { ...payload },
    })
    .catch((err) => err.response);
};

// pkg:calls https://swagger.launchmobility.io/backend#post_email_confirm_email
export const fetchEmailConfirm = (payload) => {
  return api.post('/auth/email_confirm', payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#post_password_reset_email
export const fetchSendPasswordReset = (payload) => {
  return api.post('/auth/password_reset', payload);
};

export const fetchPhoneConfirm = (payload) => {
  const url = payload.params ? `/auth/phone_confirm/${payload.params}` : '/auth/phone_confirm';
  return api.post(url, payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#put_update_user_status
export const fetchUpdateUserStatus = (id, payload) => {
  return api.put(`/user/${id}/update_status`, payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#put_update_user_role
export const fetchUpdateUserRole = (id, payload) => {
  return api.put(`/user/${id}/role`, payload);
};

export const fetchUserVehicleGroups = (id, params) => {
  return api.get(`/user/${id}/vehicle_group`, params);
};

// pkg:calls https://swagger.launchmobility.io/backend#post_vehicle_groups_by_id_post_user_user_id_vehicle_group
export const fetchAddUserVehicleGroups = (id, payload) => {
  return api.post(`/user/${id}/vehicle_group`, payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#delete_modify_user_to_vehicle_groups
export const fetchDeleteUserVehicleGroups = (id, goupId) => {
  return api.delete(`/user/${id}/vehicle_group/${goupId}`);
};

// pkg:calls https://swagger.launchmobility.io/backend#delete_modify_user_to_user_groups
export const fetchDeleteUserGroups = (id, goupId) => {
  return api.delete(`/user/${id}/user_group/${goupId}`);
};

// pkg:calls https://swagger.launchmobility.io/backend#put_user_by_id
export const fetchUpdateUser = (id, payload) => {
  return api.put(`/user/${id}`, payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#post_user_qualification_by_id
export const fetchUpdateUserQualifications = (id, payload) => {
  return api.post(`/user/${id}/qualification`, payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#get_user_privileges
export const fetchUserPrivileges = (id) => {
  return api.get(`/user/${id}/privileges`);
};

export const fetchAddNfcCard = (payload) => {
  return api.post('/access_device/broker ', payload);
};

// pkg:calls https://swagger.launchmobility.io/backend#get_user_groups_by_id
export const fetchUserGroups = (id, params) => {
  return api.get(`/user/${id}/user_group`, params);
};

// pkg:calls https://swagger.launchmobility.io/backend#post_user_groups_by_id
export const fetchAddUserGroups = (id, userGroup) => {
  return api.post(`/user/${id}/user_group`, { group_id: userGroup });
};

// pkg:calls https://swagger.launchmobility.io/backend#get_account_signatures
export const getAccountBrokers = (id) => {
  return api.get(`/account/${id}/broker_keys`);
};

// pkg:calls https://swagger.launchmobility.io/backend#post_deletion_request_user_by_id
export const fetchDeletionUser = (id, body) => {
  return api.post(`/user/${id}/deletion_request`, body);
};
